<div class="panel-heading">
	<button type="button" (click)= "onRemove()" class="close" style="color: #ffffff; margin-left: 10px; display: block">
		&times;
	</button>

	<!-- Minimize/Maximize Arrows -->
	<button (click)="this.showBody = !this.showBody" type="button" class="close" style="color: #ffffff; margin-left: 10px;">
		<i *ngIf="showBody" class="fa fa-angle-double-up"></i>
		<i *ngIf="!showBody" class="fa fa-angle-double-down"></i>
	</button>
	
	<h1 class="panel-title" style="display: inline-block; width: 90%">
		<div style="display: inline-block; width: 150px">
			<i class="fa fa-location-arrow" ></i>&nbsp;LOCATION
		</div>
	</h1>
</div>

<!-- <div *ngIf="showBody" class="panel-body" > -->
<div [style.display]="!showBody? 'none' : ''" class="panel-body" >
	<div *ngIf="locations.length == 0">	
		<p style="color: #ffffff; font-size: 15px; text-align: center;" > No locations or zones available to use. </p>
	</div>
	<ng-container>
		<tree-root
			[nodes]="nodes" 
			[options]="options"
			(stateChange)="onStateChange($event)"
			(initialized)="onInitialized($event)"
			(updateData)="onUpdateData($event)"
			></tree-root>
	</ng-container>
</div>
